import { render, staticRenderFns } from "./CarbonSystemConstruction.vue?vue&type=template&id=8f969064&scoped=true"
import script from "./CarbonSystemConstruction.vue?vue&type=script&lang=js"
export * from "./CarbonSystemConstruction.vue?vue&type=script&lang=js"
import style0 from "./CarbonSystemConstruction.vue?vue&type=style&index=0&id=8f969064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f969064",
  null
  
)

export default component.exports